<template>
	<!-- eslint-disable -->
	<div>
		<breadcrumb :items="breadcrumbs"></breadcrumb>

		<v-container fluid>
			<div>
				<v-card>
					<v-tabs class="mt-4 mb-5" v-model="mainTab">
						<v-tab>{{ $t("deforestation.allReport") }}</v-tab>
					</v-tabs>
				</v-card>
				<v-tabs-items v-model="mainTab">

					<v-tab-item>
						<div class="page-title">
							<h2 class="mb-4 pa-4">{{ $t("deforestation.eudrForestAssessment") }}</h2>
							<v-btn color="primary" @click="farmListDialogModel = true">
								{{ $t("deforestation.requestEudrForestAssessment") }}
							</v-btn>
						</div>
						<!-- <v-card elevation="10" class="" v-if="!deforestations || deforestations.rows.length == 0">
							<v-card-text>
								<div class="text-center">
									<v-row justify="center">
										<v-col cols="12" sm="4">
											<div class="py-16">
												<img src="/img/Notes.svg" /><br />
												<div class="py-4">
													<small>You haven't requested any analysis report yet. Please click the
														button below to get started.</small>
												</div>
												<v-btn color="primary" @click="farmListDialogModel = true">
													REQUEST FOREST ANALYSIS
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</div>
							</v-card-text>
						</v-card> -->
						<v-card elevation="10" class="">
							<v-card-text>
								<div class="d-flex mt-5">
									<v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px"
										:placeholder="$t('search')" dense v-model="searchPhase" class="shrink"></v-text-field>
									<v-btn color="primary" height="40" width="40" max-width="40" outlined class="ml-8"
										@click="refreshTable">
										<v-icon>mdi-refresh</v-icon>
									</v-btn>
									<v-spacer></v-spacer>
									<div class="py-1 title">
										{{ from }} - {{ to }} of {{ totalDeforestations }}
									</div>
									<v-btn class="mx-2" fab small outlined color="primary"
										:disabled="tableOptions.page <= 1" @click="pageChange(false)">
										<v-icon dark> mdi-chevron-left </v-icon>
									</v-btn>
									<v-btn class="mx-2" fab small outlined color="primary"
										:disabled="tableOptions.page >= totalPages" @click="pageChange(true)">
										<v-icon dark> mdi-chevron-right </v-icon>
									</v-btn>
									<!-- <v-btn class="mx-2" fab small outlined color="primary">
			<v-icon dark>
				mdi-cog-outline
			</v-icon>
			</v-btn> -->


									<!-- <v-menu v-model="customizeMenu" :close-on-content-click="false" :nudge-width="200"
										left :min-width="417">
										<template v-slot:activator="{ on, attrs }">
											<v-btn class="mx-2" fab small outlined color="primary" v-bind="attrs"
												v-on="on">
												<v-icon dark> mdi-cog-outline </v-icon>
											</v-btn>
										</template>

										<v-card width="417">
											<v-list>
												<v-list-item>
													<v-list-item-content>
														<v-list-item-title>{{
																$t("customization")
														}}</v-list-item-title>
													</v-list-item-content>
												</v-list-item>
												<v-divider></v-divider>
												<div class="pl-3 pt-2 font-weight-normal">
													{{ $t("recordsPerPage") }}
												</div>
												<v-list-item>
													<v-list-item-content>
														<v-slider v-model="itemsPerPageSlider"
															:tick-labels="itemsPerPageOptions" :max="3" step="1"
															ticks="always" tick-size="4"></v-slider>
													</v-list-item-content>
												</v-list-item>
												<v-divider class="mt-n3"></v-divider>
											</v-list>
											<v-card-text>
												<v-container fluid>
													<v-row>
														<v-col class="mt-n9" cols="6" v-for="header in reportHeaders"
															:key="header.value">
															<v-checkbox v-model="selectedHeaders" :label="header.text"
																color="primary" :value="header.text" hide-details
																:disabled="
																	header.text == 'ID' || header.text == 'Tag'
																"></v-checkbox>
														</v-col>
													</v-row>
												</v-container>
											</v-card-text>
											<v-layout justify-center>
												<v-card-actions class="mb-5">
													<v-spacer></v-spacer>

													<v-btn outlined color="primary" @click="resetDefaut" width="190">
														{{ $t("restoreDefault") }}
													</v-btn>
													<v-btn color="primary" @click="resetTableStructure" width="190">
														{{ $t("apply") }}
													</v-btn>
												</v-card-actions>
											</v-layout>
										</v-card>
									</v-menu> -->

									<!-- <v-btn class="mx-2" fab small outlined color="primary" @click="exportToPDF('document')"
										:disabled="deforestations && !deforestations.rows?.length">
										<v-icon>mdi-tray-arrow-down</v-icon>
									</v-btn>
									<v-btn class="mx-2" fab small outlined color="primary" @click="printPDF('document')"
										:disabled="deforestations && !deforestations.rows?.length">
										<v-icon dark> mdi-printer </v-icon>
									</v-btn> -->
								</div>
								<div ref="document" v-if="deforestations && deforestations.rows.length > 0">
									<v-data-table :headers="tableHeaders" :items="deforestations && deforestations.rows"
										item-key="id" :hide-default-footer="true" :options.sync="tableOptions">
										<template v-slot:top>

										</template>
										<template v-slot:item.farmername="{ item }">
											{{ item.farmerName || 'N/A' }}
										</template>
										<template v-slot:item.createdAt="{ item }">
											{{ formatDate(item.createdAt) }}
										</template>
										<template v-slot:item.geofenceArea="{ item }">
											{{ `${item.geofenceArea} HA` }}
										</template>
										<template v-slot:item.sateliteResponse.GeofenceArea="{ item }">
											{{ item.sateliteResponse && item.sateliteResponse.GeofenceArea || 'N/A' }}
										</template>
										<template v-slot:item.sateliteResponse.deforestationArea="{ item }">
											{{ item.sateliteResponse && item.sateliteResponse.deforestationArea ||
												'N/A'
											}}
										</template>
										<template v-slot:item.sateliteResponse.treeGainArea="{ item }">
											{{ item.sateliteResponse && item.sateliteResponse.treeGainArea ||
												'N/A'
											}}
										</template>
										<template v-slot:item.sateliteResponse.forestArea2022="{ item }">
											{{ item.sateliteResponse && item.sateliteResponse.forestArea2022 ||
												'N/A'
											}}
										</template>
										<template v-slot:item.status="{ item }">
											<v-chip outlined
												:color="item.status === 'REQUESTED' ? 'green' : item.status === 'CERTIFICATE_READY' ? 'gray' : 'red'">
												{{ item.status === 'REQUESTED' ? 'Assessment Issued' : item.status ===
													'CERTIFICATE_READY' ? 'Certificate Issued' : 'UNKNOWN' }}
											</v-chip>
										</template>
										<template v-slot:item.view="{ item }">
											<v-btn x-small fab  class="green-shadow" color="primary"
												outlined @click="viewReport(item)">
												<v-icon color="primary">mdi-clipboard-text-outline</v-icon>
											</v-btn>
										</template>

									</v-data-table>
								</div>
								<div v-else-if="loading">
									<v-progress-linear indeterminate color="green"></v-progress-linear>
								</div>
								<div class="text-center" v-else>
									<v-row justify="center">
										<v-col cols="12" sm="4">
											<div class="py-16">
												<img src="/img/Notes.svg" /><br />
												<strong>{{ $t("deforestation.noRecordFound") }}</strong><br />
												<div class="py-4">
													<small>{{ $t("deforestation.noDeforestationReportMsg") }}</small>
												</div>
												<v-btn color="primary" @click="farmListDialogModel = true">
													{{ $t("deforestation.requestEudrForestAssessment") }}
												</v-btn>
											</div>
										</v-col>
									</v-row>
								</div>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs-items>

				<!-- <PrimaryGeofence v-if="showMap"
				:farm="farm"
				:showMap="showMap" @close-location-modal="locationMapClosed"
					@close-without-change="showMap = false" /> -->

				<PrimaryGeofence v-if="showMap" :showMap="showMap" @close-location-modal="locationMapClosed"
					@close-without-change="showMap = false" />

				<GeoFenceView v-if="showGeofenceOnMap" :dialogU="showGeofenceOnMap" :polygonCoords="currentGeofenceLatLng"
					:title="dialogTitle" :satelliteImage="deforestationImage"
					:lat="selectedReport && selectedReport.latitude" :lng="selectedReport && selectedReport.longitude"
					@dialog-closed="geoFenceMapViewClosed" />

				<template>
					<div class="text-center">
						<v-dialog v-model="viewImagesDialog" width="500">
							<v-card>
								<v-toolbar dark color="primary">
									<v-card-title>
										<span class="text-h5">{{ $t("deforestation.deforestationImage") }}</span>
									</v-card-title>
									<v-spacer></v-spacer>
									<v-btn icon dark @click="viewImagesDialog = false">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</v-toolbar>
								<v-row>
									<v-col cols="12"
										v-for="(image, idx) in selectedReport && selectedReport.sateliteResponse"
										:key="idx">
										<v-img :src="image.imagePath" />
									</v-col>
								</v-row>
							</v-card>
						</v-dialog>
					</div>
				</template>

				<template>
					<div class="text-center">
						<v-dialog v-model="requestDeforestationDialog" width="500"
							@click:outside="requestDeforestationDialog = false" :retain-focus="false">
							<v-card class="custom-card" rounded="0">
								<v-toolbar color="secondary" class="white--text">
									<v-toolbar-title class="font-weight-bold">
										{{ $t("deforestation.reqDeforestationReport") }}
									</v-toolbar-title>
									<v-spacer></v-spacer>
									<v-btn icon class="white--text" @click="requestDeforestationDialog = false">
										<v-icon>mdi-close</v-icon>
									</v-btn>
								</v-toolbar>
								<v-form ref="addUser" lazy-validation autocomplete="off">
									<v-card-text class="black--text">
										<v-row>
											<v-col cols="12">
												<v-radio-group v-model="radioGroup">
													<v-radio label="Select Farm" :value="1"></v-radio>
													<v-radio label="Use New Geofence" :value="2"></v-radio>
												</v-radio-group>
											</v-col>
										</v-row>
										<v-divider class="mt-5"></v-divider>
										<v-card-actions class="mt-10" style="padding-right: 0">
											<v-spacer></v-spacer>
											<v-btn outlined class="mr-2" right height="44" depressed color="primary"
												@click="requestDeforestationDialog = false">
												{{ $t("farm.cancel") }}
											</v-btn>
											<v-btn right height="44" width="116" color="primary" @click="openFarmList">
												{{ $t("deforestation.confirm") }}
											</v-btn>
										</v-card-actions>
									</v-card-text>
								</v-form>
							</v-card>
						</v-dialog>
					</div>
				</template>

				<template>
					<v-dialog v-model="comparisionDialog" @click:outside="comparisionDialog = false" :retain-focus="false">
						<v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									{{ dialogTitle }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="comparisionDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>

							<div class="image-comparision-wrapper">
								<span class="after-image-title">Dec 2020</span>
								<span class="before-image-title">{{ $t("deforestation.currentDate") }}</span>
								<img-comparison-slider class="slider-with-animated-handle rendered" tabindex="0">
									<img slot="before" class="before-image" :src="beforeImage" />
									<img slot="after" class="after-image" :src="deforestationImage" />

									<svg slot="handle" class="custom-animated-handle" xmlns="http://www.w3.org/2000/svg"
										width="100" viewBox="-8 -3 16 6">
										<path stroke="#5959FF"
											d="M -5 -2 L -7 0 L -5 2 M -5 -2 L -5 2 M 5 -2 L 7 0 L 5 2 M 5 -2 L 5 2"
											stroke-width="1" fill="#5959FF" vector-effect="non-scaling-stroke"></path>
									</svg>
								</img-comparison-slider>
							</div>

							<div class="legend">
								<span class="legend-item"><span class="light-green"></span> {{ $t("deforestation.newForestArea") }}</span>
								<span class="legend-item"><span class="red"></span> {{ $t("deforestation.deforestedArea") }}</span>
								<span class="legend-item"><span class="dark-green"></span>{{ $t("deforestation.deforestedArea") }}</span>
							</div>


						</v-card>
					</v-dialog>
					<v-dialog v-model="farmListDialogModel" @click:outside=" farmListDialogModel = false"
						:retain-focus="false" width="500">
						<v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									{{ $t("deforestation.pleaseChooseOption") }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="farmListDialogModel = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-form ref="addUser" lazy-validation autocomplete="off">
								<v-card-text class="black--text">
									<v-row>
										<v-col cols="12">

											<v-radio-group v-model="farmType">
												<v-radio class="d-flex align-center" :label="$t('deforestation.registerFarm')"
													value="registered"></v-radio>
												<v-radio class="d-flex align-center mb-2" :label="$t('deforestation.nonRegisterFarm')"
													value="non-registered"></v-radio>
											</v-radio-group>
										</v-col>
									</v-row>
									<v-divider class="mt-5"></v-divider>
									<v-card-actions class="mt-10" style="padding-right: 0">
										<v-spacer></v-spacer>
										<v-btn outlined class="mr-2" right height="44" width="116" depressed color="primary"
											@click="closeModal()">
											{{ $t("farm.cancel") }}
										</v-btn>
										<v-btn right height="44" width="116" color="primary"
											@click="() => { farmType == 'registered' ? selectFarmDialog = true : registerFarmDialog = true; farmListDialogModel = false }">
											{{ $t("deforestation.confirm") }}
										</v-btn>
									</v-card-actions>
								</v-card-text>
							</v-form>
						</v-card>
						<!-- <v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									{{ "Farm List" }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="farmListDialogModel = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text>
								<v-radio-group v-model="selectedFarmRadio">

									<v-data-table :headers="farmHeaders" :items="items"
										:items-per-page="farmTableOptions.itemsPerPage" :loading="loading"
										loading-text="Loading Farms... Please wait" :footer-props="{
											'items-per-page-options': farmItemsPerPageOptions,
											'show-first-last-page': true,
											'show-current-page': true,
											'items-per-page-text': 'Farms per page',
										}" :options.sync="farmTableOptions" :server-items-length="totalfarms" hide-default-footer :header-props="{
	'sort-icon': 'mdi-unfold-more-horizontal'
}">

										<template v-slot:item.farmCheckBox="{ item }">
											<v-tooltip top>
												<template v-slot:activator="{ on, attrs }">
													<div v-bind="attrs" v-on="on">
														<v-radio :value="item"> </v-radio>
													</div>
												</template>
												<span>{{ $t("Select One Farm to Generate a Deforestation Report") }}</span>
											</v-tooltip>
										</template>

										<template v-slot:top>
											<div class="d-flex mt-5">
												<v-text-field prepend-inner-icon="mdi-magnify" outlined height="5px"
													:placeholder="$t('farm.searchState')" dense v-model="search"
													@click:append="searchFarms" @input="resetSearchOnEmpty"
													class="shrink"></v-text-field>

												<v-spacer></v-spacer>
												<div class="py-1 title">
													{{ farmFrom }} - {{ farmTo }} of {{ totalfarms }}
												</div>
												<v-btn class="mx-2" fab small outlined color="primary"
													:disabled="farmTableOptions.page <= 1" @click="farmPageChange(false)">
													<v-icon dark> mdi-chevron-left </v-icon>
												</v-btn>
												<v-btn class="mx-2" fab small outlined color="primary"
													:disabled="farmTableOptions.page >= farmTotalPages"
													@click="farmPageChange(true)">
													<v-icon dark> mdi-chevron-right </v-icon>
												</v-btn>

											</div>
										</template>
										<template v-slot:progress>
											<v-progress-linear color="primary" :height="8"
												indeterminate></v-progress-linear>
										</template>

									</v-data-table>
								</v-radio-group>

								<v-divider class="mt-5"></v-divider>
								<v-card-actions class="mt-10" style="padding-right: 0">
									<v-spacer></v-spacer>
									<v-btn outlined class="mr-2" right height="44" depressed color="primary"
										@click="farmListDialogModel = false">
										Cancel
									</v-btn>
									<v-btn right height="44" width="116" color="primary"
										@click="requestReportFromFarmSelection">
										Confirm
									</v-btn>
								</v-card-actions>
							</v-card-text>
						</v-card> -->
					</v-dialog>
					<!-- select farm/zone for registered farm report-->
					<v-dialog v-model="selectFarmDialog" width="500" @click:outside="selectFarmDialog = false"
						:retain-focus="false">
						<v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									{{ $t("deforestation.requestForestReport") }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="selectFarmDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text class="black--text">
								<v-row class="mt-5">
									<v-col cols="12">
										<label class="subtitle-1" for="Select Farm">{{ $t("farm.farmName") }} <span class="red--text">*</span></label>
										<v-select :items="items" :item-text="'farmName'" :placeholder="$t('farm.selectFarm')"
											:item-value="'id'" outlined v-model="selectedFarm" :rules="farmRules.farmName"
											@change="getFarmDetails"></v-select>

										<label class="subtitle-1" for="Select Zone" v-if="geofences.length">{{ $t("farm.farmZone") }}</label>
										<v-select :items="geofences" outlined v-model="geofence" v-if="geofences.length"
											:item-text="'geofenceName'" :item-value="'id'"
											:return-object="true"
											placeholder="Select Zone"></v-select>

									</v-col>
								</v-row>
								<v-card-actions class="mt-10" style="padding-right: 0">
									<v-spacer></v-spacer>
									<v-btn @click="selectFarmDialog = false" outlined class="mr-2 px-5" right height="44"
										depressed color="primary">
										{{ $t("farm.cancel") }}
									</v-btn>
									<v-btn @click="requestReportFromFarmSelection" right height="44" color="primary"
										class="px-5">
										{{ $t("sendRequest") }}
									</v-btn>
								</v-card-actions>
							</v-card-text>
						</v-card>
					</v-dialog>
					<!-- Register farm for non registered farm report -->
					<v-dialog v-model="registerFarmDialog" width="500" @click:outside="registerFarmDialog = false"
						:retain-focus="false">
						<v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									 {{ $t("deforestation.requestForestReport") }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="registerFarmDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text class="black--text">

								<v-row class="mt-5">

									<v-col cols="12">
										<v-form @submit.prevent="requestNonRegisteredReport" ref="registerForm"
											lazy-validation>
											<label class="subtitle-1" for="text"> {{ $t('farm.farmName')
											}} </label>
											<v-text-field v-model="farm.farmName" :placeholder="$t('farm.farmName')"
												outlined dense required ></v-text-field>
											<label class="subtitle-1" for="text"> {{ $t('deforestation.farmRegistrationId')
											}} </label>
											<v-text-field v-model="farm.farmRegistrationId"
												:placeholder="$t('deforestation.farmRegistrationId')" outlined dense required
											></v-text-field>
											<label class="subtitle-1" for="text">{{ $t('farm.farmerName') }} 
											</label>
											<v-text-field v-model="farm.farmOwner" outlined dense item-text="farmOwner"
												item-value="id" :placeholder="$t('farm.farmOwner')"
											></v-text-field>
											<label class="subtitle-1" for="text"> {{ $t('deforestation.farmerRegistrationId')
											}} </label>
											<v-text-field v-model="farm.farmerRegistrationId"
												:placeholder="$t('deforestation.farmerRegistrationId')" outlined dense required
											></v-text-field>
											<label>{{ $t('farm.farmLocation') }} <span class="red--text">*</span></label>
											<v-text-field :rules="farmRules.address" readonly
												@click="showFarmLocation = true" id="dialog-link1"
												placeholder="Please click to choose location" outlined dense
												v-model="farm.address">
											</v-text-field>
										</v-form>
									</v-col>

								</v-row>
								<v-card-actions class="mt-10" style="padding-right: 0">
									<v-spacer></v-spacer>
									<v-btn @click="() => { registerFarmDialog = false; selectFarmDialog = false }" outlined
										class="mr-2 px-5" right height="44" depressed color="primary">
										{{ $t("farm.cancel") }}
									</v-btn>
									<v-btn @click="requestNonRegisteredReport" right height="44" color="primary"
										class="px-5">
										{{ $t("sendRequest") }}
									</v-btn>
								</v-card-actions>
							</v-card-text>
						</v-card>
					</v-dialog>
					<!-- success dialog -->
					<v-dialog v-model="successDialog" width="500" @click:outside="successDialog = false"
						:retain-focus="false">
						<v-card class="custom-card" rounded="0">
							<v-toolbar color="secondary" class="white--text">
								<v-toolbar-title class="font-weight-bold">
									{{ $t("success") }}
								</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon class="white--text" @click="successDialog = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-form ref="addUser" lazy-validation autocomplete="off">
								<v-card-text class="black--text">
									<v-row>
										<v-col cols="12">
											<div class="mb-5 mt-5 text-md-center">
												<div>
													<svg width="108" height="121" viewBox="0 0 108 121" fill="none"
														xmlns="http://www.w3.org/2000/svg">
														<path
															d="M92.8563 36.1122C86.5703 36.1405 81.4694 30.583 81.4382 23.6718C81.4332 22.5558 81.5841 21.396 81.8526 20.3216L53.7803 20.4483C52.6871 20.4532 51.7935 21.4446 51.7989 22.6465L52.1126 92.1015C52.118 93.3034 53.0205 94.2867 54.1137 94.2818L97.2568 94.0871C98.35 94.0822 99.2436 93.0909 99.2381 91.8889L98.9772 34.1099C97.148 35.406 95.0427 36.1023 92.8563 36.1122Z"
															fill="#EDF4FC" />
														<path
															d="M51.8087 24.7927C51.6526 24.7934 51.4964 24.7941 51.3792 24.7946C49.8565 24.8015 48.375 25.2804 47.0514 26.1449C45.5159 23.3186 42.7361 21.6141 39.7688 21.6275L35.4349 21.647C27.0017 21.728 20.203 29.2709 20.2059 38.5432L20.2398 46.0554C21.6009 44.8473 23.3165 44.3244 25.0358 44.6171L25.0323 43.8444C25.0301 43.3723 25.3798 42.9843 25.8093 42.9824L25.9654 42.9817C28.6621 43.5705 36.6319 44.6077 42.0252 37.114C42.2968 36.7265 42.8041 36.6813 43.1569 36.9802C43.1959 36.98 43.1961 37.0229 43.2352 37.0227C44.3338 38.2197 47.0379 40.4398 51.8822 41.0618L51.8087 24.7927Z"
															fill="#818182" />
														<path
															d="M51.882 41.062C46.9987 40.4401 44.3336 38.2199 43.235 37.0229C42.9211 36.6809 42.4135 36.6832 42.1027 37.028C42.0639 37.0711 42.0639 37.0711 42.0641 37.114C36.6708 44.6077 28.7012 43.6134 26.0043 42.9817C25.5744 42.8978 25.1463 43.2002 25.0704 43.6727L25.0711 43.8444L25.1303 56.937C25.2098 65.9084 31.8411 73.1762 40.0012 73.1394C44.7645 73.1179 49.2429 70.522 51.9958 66.2598L51.882 41.062Z"
															fill="#454545" />
														<path
															d="M88.6967 102.208L87.8377 102.212L87.8333 101.224C87.83 100.495 87.2808 99.939 86.6562 99.9419C85.9924 99.9448 85.4876 100.548 85.4907 101.235L85.4949 102.179L84.636 102.183C83.9722 102.186 83.4674 102.789 83.4705 103.476C83.4738 104.206 84.0229 104.762 84.6476 104.759L85.5066 104.755L85.5108 105.699C85.5141 106.429 86.0632 106.985 86.6879 106.982C87.3517 106.979 87.8565 106.376 87.8534 105.689L87.8492 104.744L88.7081 104.74C89.3719 104.737 89.8767 104.134 89.8736 103.447C89.9096 102.76 89.3604 102.205 88.6967 102.208Z"
															fill="#70D6F9" />
														<path
															d="M27.0382 3.91304C27.7282 3.90993 28.2848 3.2924 28.2814 2.53376C28.2779 1.77512 27.7158 1.16264 27.0258 1.16575C26.3357 1.16886 25.7791 1.78639 25.7826 2.54503C25.786 3.30368 26.3481 3.91616 27.0382 3.91304Z"
															fill="#70D6F9" />
														<path
															d="M106.08 103.405C106.77 103.402 107.327 102.785 107.323 102.026C107.32 101.268 106.758 100.655 106.068 100.658C105.378 100.661 104.821 101.279 104.825 102.037C104.828 102.796 105.39 103.409 106.08 103.405Z"
															fill="#F5C84C" />
														<path
															d="M82.5987 117.95C83.2887 117.947 83.8453 117.33 83.8419 116.571C83.8385 115.812 83.2763 115.2 82.5863 115.203C81.8963 115.206 81.3397 115.824 81.3431 116.582C81.3465 117.341 81.9087 117.954 82.5987 117.95Z"
															fill="#87D147" />
														<path
															d="M7.93496 21.9858C6.37186 21.6923 5.1555 20.3671 4.8356 18.6943C4.8354 18.6514 4.79616 18.6087 4.75731 18.6518C4.71827 18.652 4.71846 18.6949 4.71846 18.6949C4.41387 20.4133 3.20934 21.7066 1.64895 22.0141C1.60991 22.0143 1.57106 22.0574 1.57125 22.1003C1.57145 22.1433 1.61049 22.1431 1.64973 22.1858C3.21283 22.4793 4.42918 23.8045 4.74909 25.4773C4.74929 25.5202 4.78852 25.5629 4.82737 25.5198C4.86642 25.5197 4.86622 25.4767 4.86622 25.4767C5.17082 23.7583 6.37535 22.465 7.93574 22.1575C7.97478 22.1573 8.01363 22.1142 8.01344 22.0713C8.01324 22.0283 7.974 21.9856 7.93496 21.9858Z"
															fill="#F5C84C" />
														<path
															d="M5.49074 69.4314C4.4356 69.2215 3.57257 68.324 3.33308 67.166C3.33288 67.1231 3.29384 67.1233 3.29384 67.1233C3.2548 67.1234 3.2548 67.1234 3.25499 67.1664C3.02596 68.3264 2.21012 69.2316 1.11787 69.4512C1.07883 69.4513 1.07902 69.4943 1.07902 69.4943C1.07921 69.5372 1.07921 69.5372 1.11826 69.537C2.1734 69.7469 3.03643 70.6445 3.27593 71.8024C3.27612 71.8453 3.31516 71.8452 3.31516 71.8452C3.35421 71.845 3.35421 71.845 3.35401 71.8021C3.58304 70.642 4.39888 69.7368 5.49113 69.5173C5.53018 69.5171 5.49094 69.4743 5.49074 69.4314C5.49094 69.4743 5.49094 69.4743 5.49074 69.4314Z"
															fill="#FC657E" />
														<path
															d="M68.8208 8.20462C67.7657 7.99474 66.9026 7.09716 66.6632 5.93921C66.663 5.89628 66.6239 5.89645 66.6239 5.89645C66.5849 5.89663 66.5849 5.89663 66.5851 5.93956C66.356 7.09963 65.5402 8.00478 64.4479 8.22434C64.4089 8.22452 64.4091 8.26745 64.4091 8.26745C64.4093 8.31038 64.4093 8.31038 64.4483 8.3102C65.5035 8.52008 66.3665 9.41765 66.606 10.5756C66.6062 10.6185 66.6452 10.6184 66.6452 10.6184C66.6843 10.6182 66.6843 10.6182 66.6841 10.5753C66.9131 9.41519 67.729 8.51004 68.8212 8.29047C68.8603 8.2903 68.821 8.24754 68.8208 8.20462C68.821 8.24754 68.821 8.24754 68.8208 8.20462Z"
															fill="#FC657E" />
														<path
															d="M25.1304 56.9368L25.0748 44.6169C21.7143 44.0311 18.5242 46.5782 17.9943 50.2723C17.4643 53.9664 19.7838 57.476 23.1442 58.0618C23.8086 58.1876 24.5113 58.1845 25.1745 58.0527C25.1337 57.6665 25.1322 57.3231 25.1304 56.9368Z"
															fill="#454545" />
														<path
															d="M72.1518 94.1573L54.1137 94.2387C53.0205 94.2436 52.118 93.2603 52.1126 92.0584L52.054 79.0946L49.9797 77.9879C48.3358 77.0938 47.3125 75.2955 47.3034 73.2779L47.2929 70.9599C45.0739 72.3865 42.5784 73.1275 40.0015 73.1392C37.4246 73.1508 34.9225 72.4323 32.6906 71.0258L32.7011 73.3438C32.7102 75.3614 31.7032 77.1688 30.0675 78.0777L26.6011 79.9821C25.7443 80.4582 24.8479 80.8057 23.912 81.0674L12.9934 84.1216C10.3417 84.8633 8.44018 87.4476 8.29758 90.4531L6.57826 116.088C6.4683 117.677 7.56792 119.089 9.01311 119.211L9.20833 119.21L71.2095 118.931C72.6541 118.924 73.8586 117.631 73.8513 116C73.8509 115.914 73.8505 115.828 73.8503 115.785L72.1518 94.1573Z"
															fill="#48BF84" />
														<path
															d="M52.0542 79.1377L49.9799 78.0309C48.336 77.1369 47.3127 75.3386 47.3036 73.321L47.2931 71.003C45.074 72.4296 42.5785 73.1706 40.0017 73.1822C37.4248 73.1939 34.9227 72.4754 32.6908 71.0689L32.7013 73.3869C32.7104 75.4044 31.7034 77.2119 30.0677 78.1208L27.536 79.5059C30.2514 84.2156 34.9886 87.0704 40.0643 87.0475C44.8276 87.026 49.306 84.4302 52.0589 80.1679L52.0542 79.1377Z"
															fill="#454545" />
														<path
															d="M39.9664 65.3696C37.2724 65.3818 34.7669 63.8906 33.3501 61.4072C33.0744 60.8934 33.1887 60.2489 33.6556 59.9034C34.1226 59.5579 34.709 59.7269 35.0237 60.2407C36.7552 63.2378 40.3513 64.123 43.0758 62.2219C43.8153 61.7034 44.4369 61.0138 44.9017 60.1961C45.1727 59.6797 45.7968 59.5481 46.2667 59.8465C46.7366 60.1449 46.8568 60.8312 46.5858 61.3475C45.1523 63.8008 42.6604 65.3575 39.9664 65.3696Z"
															fill="black" />
														<path
															d="M33.5503 53.937C34.5206 53.9326 35.3033 53.0642 35.2985 51.9974C35.2937 50.9305 34.5032 50.0692 33.5328 50.0736C32.5625 50.078 31.7798 50.9464 31.7846 52.0132C31.7894 53.0801 32.5799 53.9414 33.5503 53.937Z"
															fill="black" />
														<path
															d="M46.5908 53.8782C47.5612 53.8738 48.3439 53.0054 48.339 51.9385C48.3342 50.8717 47.5437 50.0104 46.5734 50.0148C45.603 50.0192 44.8203 50.8876 44.8251 51.9544C44.8299 53.0212 45.6205 53.8825 46.5908 53.8782Z"
															fill="black" />
														<path
															d="M24.1643 59.2165C20.2209 59.2343 16.9646 55.7718 16.9448 51.3933C16.9251 47.0148 20.0717 43.4806 24.0541 43.4626C24.4446 43.4609 24.8352 43.502 25.2258 43.5432C25.6948 43.6269 26.0481 44.0546 26.0506 44.6127L26.1062 56.9326C26.1076 57.233 26.1091 57.5765 26.1499 57.9626C26.1915 58.5205 25.8422 58.9943 25.3351 59.0824C24.945 59.17 24.5548 59.2147 24.1643 59.2165ZM24.1029 45.6088C21.2137 45.6218 18.9217 48.2078 18.9359 51.3414C18.9502 54.518 21.3043 57.0401 24.1544 57.0272C24.1543 56.9843 24.1541 56.9414 24.1539 56.8984L24.1029 45.6088Z"
															fill="black" />
														<path
															d="M71.2144 120.047L9.25228 120.326C7.26106 120.335 5.61328 118.583 5.6032 116.351C5.60281 116.265 5.60223 116.136 5.60184 116.05L7.32116 90.4147C7.46163 86.9369 9.67393 84.0079 12.7545 83.1354L23.6731 80.0813C24.5309 79.8198 25.3495 79.5156 26.1674 79.0827L29.6338 77.1782C30.9191 76.4856 31.7715 75.0222 31.7253 73.4341L31.7148 71.1161C31.7121 70.5151 32.1394 70.041 32.686 70.0385C32.8422 70.0378 33.0376 70.0799 33.1551 70.1652C37.3839 72.8076 42.5767 72.7842 46.7813 70.1037C47.2485 69.8011 47.8349 69.9702 48.1106 70.4841C48.1894 70.6554 48.2292 70.827 48.23 70.9987L48.2405 73.3167C48.2477 74.905 49.0742 76.3608 50.3657 77.0418L52.4401 78.1485C52.7922 78.3187 52.9892 78.7041 52.9909 79.0905L53.0495 92.0542C53.0522 92.6552 53.484 93.1684 54.0696 93.1658L72.1078 93.0844C72.6153 93.0821 73.0467 93.5094 73.0883 94.0673L74.7479 115.738C74.914 117.927 73.4391 119.865 71.4486 120.046C71.3705 120.046 71.2924 120.046 71.2144 120.047ZM33.6747 72.8244L33.6773 73.3824C33.6881 75.7863 32.4488 78.0241 30.5013 79.0631L27.0349 80.9676C26.1393 81.4867 25.1649 81.8775 24.1509 82.1396L13.2323 85.1938C10.9705 85.805 9.37942 87.9585 9.27392 90.5346L7.55479 116.213C7.48117 117.201 8.18802 118.099 9.08641 118.181L9.20354 118.18L71.2047 117.9C72.1417 117.896 72.8799 117.077 72.8752 116.047C72.875 116.004 72.8748 115.961 72.8746 115.918L71.2975 95.2344L54.1574 95.3117C52.5176 95.3191 51.1835 93.8656 51.1754 92.0627L51.1199 79.7857L49.5936 78.977C47.5975 77.9128 46.3773 75.729 46.3664 73.3251L46.3639 72.7671C42.3121 74.7171 37.7049 74.7379 33.6747 72.8244Z"
															fill="black" />
														<path
															d="M40.0688 88.1207C34.6417 88.1452 29.5913 85.1201 26.7185 80.1106C26.4429 79.5967 26.5571 78.9523 27.024 78.6067C27.0631 78.6066 27.1019 78.5635 27.1019 78.5635L29.6336 77.1784C30.9189 76.4857 31.7713 75.0224 31.7251 73.4343L31.7146 71.1162C31.7119 70.5153 32.1392 70.0411 32.6858 70.0387C32.842 70.038 33.0374 70.08 33.1549 70.1653C37.3837 72.8077 42.5764 72.7843 46.7811 70.1039C47.2483 69.8013 47.8347 69.9703 48.1103 70.4842C48.1892 70.6556 48.229 70.8271 48.2298 70.9988L48.2403 73.3168C48.2474 74.9051 49.074 76.3609 50.3655 77.0419L52.4398 78.1487C52.792 78.3188 52.989 78.7042 52.9907 79.0906L52.9952 80.0779C52.9961 80.2925 52.919 80.5075 52.8029 80.7227C49.9344 85.3288 45.1833 88.0547 40.0688 88.1207ZM28.982 79.8857C33.5413 86.5618 42.2154 87.9393 48.2835 82.8894C49.3338 82.0261 50.305 80.9486 51.0807 79.786L49.5543 78.9773C47.5582 77.9131 46.338 75.7293 46.3271 73.3255L46.3246 72.7674C42.3121 74.7602 37.7049 74.781 33.6745 72.8245L33.677 73.3825C33.6879 75.7864 32.4486 78.0242 30.5011 79.0633L28.982 79.8857Z"
															fill="black" />
														<path
															d="M92.8611 37.1852C86.0676 37.2158 80.4961 31.1882 80.4621 23.6761C80.4282 16.164 85.9451 10.0863 92.7386 10.0557C99.5322 10.025 105.104 16.0526 105.138 23.5648C105.171 31.034 99.6547 37.1545 92.8611 37.1852ZM92.7483 12.202C87.0089 12.2279 82.3858 17.3571 82.4143 23.6673C82.4428 29.9775 87.112 35.0648 92.8514 35.0389C98.5908 35.013 103.214 29.8838 103.185 23.5736C103.157 17.2634 98.4877 12.1761 92.7483 12.202Z"
															fill="black" />
														<path
															d="M97.2614 95.1173L54.1183 95.3119C52.4785 95.3193 51.1444 93.8658 51.1363 92.0629L50.8228 22.6508C50.8147 20.8479 52.1356 19.3824 53.7754 19.375L81.8477 19.2484C82.3943 19.2459 82.8259 19.7162 82.8287 20.3172C82.829 20.403 82.8296 20.5318 82.791 20.6178C81.2956 26.6773 84.5257 32.9731 90.0774 34.6222C92.9315 35.4679 95.9747 34.9819 98.4656 33.2107C98.9327 32.9081 99.519 33.0342 99.8336 33.5479C99.9516 33.7191 99.9916 33.9335 99.9923 34.1052L100.253 91.8842C100.222 93.6444 98.9013 95.1099 97.2614 95.1173ZM53.7851 21.5214C53.2385 21.5238 52.7721 21.9981 52.775 22.642L53.0887 92.097C53.0914 92.698 53.5232 93.2112 54.1088 93.2085L97.2519 93.0139C97.7986 93.0114 98.265 92.5371 98.262 91.8932L98.0093 35.9171C91.8545 39.0786 84.501 36.1498 81.62 29.3373C80.5546 26.8524 80.2298 24.1065 80.6471 21.4002L53.7851 21.5214Z"
															fill="black" />
														<path
															d="M20.2446 47.1287C19.698 47.1311 19.2664 46.6609 19.2637 46.0599L19.2298 38.5478C19.1852 28.6747 26.4503 20.6574 35.4301 20.574L39.7639 20.5545C42.7703 20.5409 45.5495 22.1167 47.3574 24.7271C48.7596 23.991 50.3198 23.6405 51.8429 23.7195C52.3507 23.7602 52.7823 24.2304 52.7848 24.7885L52.8581 41.0146C52.8608 41.6156 52.4334 42.0897 51.8868 42.0922C51.8478 42.0924 51.8087 42.0926 51.7697 42.0927C46.8473 41.471 43.9872 39.2946 42.6926 37.9268C37.066 45.6362 28.7843 44.6862 26.0485 44.0976L26.0509 44.6127C26.0536 45.2137 25.6262 45.6878 25.0796 45.6903C25.0406 45.6904 24.9625 45.6908 24.9234 45.691C24.6499 45.6493 24.3764 45.6076 24.1031 45.6088C22.9318 45.6141 21.7625 46.0486 20.8682 46.8683C20.7128 47.0407 20.4789 47.1276 20.2446 47.1287ZM35.4398 22.7203C27.553 22.7559 21.1816 29.8247 21.1819 38.539L21.2073 44.1623C22.1034 43.729 23.0783 43.4671 24.0936 43.5054C24.284 42.4314 25.2182 41.7832 26.1562 41.9937C29.0871 42.5814 36.3529 43.3643 41.2804 36.4737C41.9013 35.6123 42.9939 35.4786 43.7779 36.1619C43.8171 36.2046 43.8563 36.2474 43.9346 36.29C44.9156 37.3587 47.0709 39.109 50.9395 39.8213L50.8767 25.9132C49.7058 26.0043 48.5753 26.3958 47.6023 27.087C47.1351 27.3896 46.5487 27.2205 46.2731 26.7066C44.8953 24.2231 42.4678 22.7316 39.8517 22.7004L35.4398 22.7203Z"
															fill="black" />
														<path
															d="M40.0066 74.2553C31.2999 74.2946 24.1979 66.5568 24.1547 56.9842L24.0954 43.8487C24.0927 43.2477 24.3244 42.6886 24.7523 42.3433C25.1801 41.955 25.7261 41.8238 26.2342 41.9502C29.0873 42.5813 36.3531 43.3641 41.2806 36.4735C41.9014 35.6122 42.9941 35.4785 43.7781 36.1618C43.8173 36.2045 43.8565 36.2473 43.9348 36.2898C44.9942 37.4441 47.4631 39.4505 52.0339 40.0309C52.5418 40.1145 52.8952 40.5422 52.8977 41.1002L53.0117 66.3409C53.0126 66.5556 52.9355 66.7706 52.8194 66.9857C49.8722 71.4635 45.0821 74.1895 40.0066 74.2553ZM26.0487 44.0974L26.1067 56.9325C26.1447 65.346 32.3442 72.1006 39.9967 72.0661C44.3696 72.0463 48.4589 69.7527 51.0576 65.9205L50.9494 41.9675C46.534 41.2148 43.948 39.2088 42.7318 37.9265C37.0662 45.6361 28.7845 44.6861 26.0487 44.0974Z"
															fill="black" />
														<path
															d="M82.3781 41.5683L68.7128 41.63C68.1662 41.6324 67.7346 41.1622 67.7319 40.5612C67.7292 39.9602 68.1565 39.4861 68.7031 39.4836L82.3684 39.422C82.915 39.4195 83.3466 39.8898 83.3493 40.4907C83.352 41.0917 82.9247 41.5658 82.3781 41.5683Z"
															fill="black" />
														<path
															d="M90.3817 50.1176L65.0815 50.2318C64.5349 50.2342 64.1033 49.764 64.1005 49.163C64.0978 48.562 64.5252 48.0879 65.0718 48.0854L90.372 47.9713C90.9186 47.9688 91.3502 48.4391 91.3529 49.0401C91.3556 49.641 90.9283 50.1152 90.3817 50.1176Z"
															fill="black" />
														<path
															d="M90.4061 55.5693L65.1059 55.6834C64.5593 55.6859 64.1277 55.2156 64.125 54.6147C64.1222 54.0137 64.5496 53.5396 65.0962 53.5371L90.3964 53.423C90.943 53.4205 91.3746 53.8908 91.3773 54.4917C91.3801 55.0927 90.9527 55.5668 90.4061 55.5693Z"
															fill="black" />
														<path
															d="M90.431 61.0209L65.1308 61.1351C64.5842 61.1375 64.1526 60.6673 64.1499 60.0663C64.1472 59.4654 64.5745 58.9912 65.1211 58.9888L90.4213 58.8746C90.9679 58.8722 91.3995 59.3424 91.4022 59.9434C91.405 60.5444 90.9776 61.0185 90.431 61.0209Z"
															fill="black" />
														<path
															d="M90.4554 66.4726L65.1552 66.5867C64.6086 66.5892 64.177 66.119 64.1743 65.518C64.1716 64.917 64.5989 64.4429 65.1455 64.4404L90.4457 64.3263C90.9923 64.3238 91.4239 64.7941 91.4267 65.395C91.4292 65.9531 91.002 66.4701 90.4554 66.4726Z"
															fill="black" />
														<path
															d="M90.4798 71.8813L65.1796 71.9954C64.633 71.9979 64.2014 71.5276 64.1987 70.9267C64.196 70.3257 64.6233 69.8516 65.1699 69.8491L90.4701 69.735C91.0167 69.7325 91.4484 70.2028 91.4511 70.8037C91.4538 71.4047 91.0264 71.8788 90.4798 71.8813Z"
															fill="black" />
														<path
															d="M90.5047 77.333L65.2045 77.4471C64.6579 77.4496 64.2263 76.9793 64.2236 76.3783C64.2209 75.7774 64.6482 75.3032 65.1948 75.3008L90.495 75.1866C91.0417 75.1842 91.4733 75.6544 91.476 76.2554C91.4787 76.8564 91.0513 77.3305 90.5047 77.333Z"
															fill="black" />
														<path
															d="M60.7086 50.2514L59.9667 50.2547C59.4201 50.2572 58.9885 49.7869 58.9858 49.186C58.9831 48.585 59.4104 48.1109 59.957 48.1084L60.6989 48.105C61.2455 48.1026 61.6771 48.5728 61.6798 49.1738C61.6825 49.7748 61.2552 50.2489 60.7086 50.2514Z"
															fill="black" />
														<path
															d="M60.7335 55.703L59.9916 55.7064C59.445 55.7088 59.0134 55.2386 59.0107 54.6376C59.008 54.0366 59.4353 53.5625 59.9819 53.56L60.7238 53.5567C61.2704 53.5542 61.702 54.0245 61.7047 54.6255C61.7074 55.2264 61.2801 55.7006 60.7335 55.703Z"
															fill="black" />
														<path
															d="M60.7579 61.1547L60.0161 61.158C59.4694 61.1605 59.0378 60.6902 59.0351 60.0893C59.0324 59.4883 59.4598 59.0142 60.0064 59.0117L60.7482 59.0084C61.2948 59.0059 61.7264 59.4762 61.7291 60.0771C61.7318 60.6781 61.3045 61.1522 60.7579 61.1547Z"
															fill="black" />
														<path
															d="M60.7823 66.6063L60.0405 66.6097C59.4939 66.6122 59.0622 66.1419 59.0595 65.5409C59.0568 64.94 59.4842 64.4658 60.0308 64.4634L60.7726 64.46C61.3192 64.4576 61.7508 64.9278 61.7535 65.5288C61.7561 66.0868 61.3289 66.6039 60.7823 66.6063Z"
															fill="black" />
														<path
															d="M60.8067 72.015L60.0649 72.0184C59.5183 72.0208 59.0867 71.5506 59.0839 70.9496C59.0812 70.3487 59.5086 69.8745 60.0552 69.8721L60.797 69.8687C61.3436 69.8662 61.7752 70.3365 61.7779 70.9375C61.7807 71.5384 61.3533 72.0126 60.8067 72.015Z"
															fill="black" />
														<path
															d="M60.8316 77.4667L60.0898 77.47C59.5432 77.4725 59.1116 77.0023 59.1089 76.4013C59.1061 75.8003 59.5335 75.3262 60.0801 75.3237L60.8219 75.3204C61.3685 75.3179 61.8001 75.7882 61.8028 76.3891C61.8056 76.9901 61.3782 77.4642 60.8316 77.4667Z"
															fill="black" />
														<path
															d="M18.4999 118.997C17.9533 118.999 17.5216 118.529 17.5189 117.928L17.4443 101.401C17.4416 100.8 17.8689 100.326 18.4155 100.324C18.9622 100.321 19.3938 100.792 19.3965 101.392L19.4711 117.919C19.4738 118.52 19.0465 118.994 18.4999 118.997Z"
															fill="black" />
														<path
															d="M62.2284 118.799C61.6818 118.802 61.2502 118.332 61.2474 117.731L61.1728 101.204C61.1701 100.603 61.5974 100.129 62.1441 100.126C62.6907 100.124 63.1223 100.594 63.125 101.195L63.1996 117.722C63.2023 118.323 62.775 118.797 62.2284 118.799Z"
															fill="black" />
														<path
															d="M92.9361 38.0277C100.213 37.9949 106.082 31.4828 106.046 23.4826C106.01 15.4823 100.082 9.02346 92.8053 9.05628C85.5287 9.08911 79.6592 15.6012 79.6953 23.6014C79.7314 31.6017 85.6595 38.0606 92.9361 38.0277Z"
															fill="#5AB74E" />
														<path
															d="M91.3029 29.8121C91.1735 29.9609 90.9964 30.0444 90.812 30.0452C90.6276 30.0461 90.4497 29.9642 90.3189 29.8165L86.3696 25.3827C85.9597 24.9226 85.9563 24.1736 86.362 23.7107L86.8515 23.1511C87.2573 22.6873 87.9178 22.6843 88.3276 23.1444L90.7933 25.9122L97.3881 18.3736C97.7939 17.9098 98.455 17.9068 98.8642 18.3669L99.3588 18.9221C99.7686 19.3822 99.772 20.1311 99.3663 20.5941L91.3029 29.8121Z"
															fill="white" />
													</svg>
												</div>
												<a class="title">{{ $t("yourRequestSuccessfullySubmitted") }}</a>

												<p>{{ $t("informShortly") }}
												</p>
											</div>

										</v-col>
									</v-row>
									<p class="mt-5"></p>
								</v-card-text>
							</v-form>
						</v-card>
					</v-dialog>
				</template>
				<PromptDialog @closeDialog="showPromptDialog=false" @saveData="saveFormData" :dialogI="showPromptDialog"
					v-if="showPromptDialog" />
				<primary-geofence v-if="showMap" :showMap="showMap" :farm="farm" @close-location-modal="locationMapClosed"
					@close-without-change="closeWithoutChange"></primary-geofence>

				<FarmLocationNonRegistered v-if="showFarmLocation" :showMap="showFarmLocation" :farm="farm"
					@close-location-modal="farmLocationClosed" @close-without-change="closeWithoutChange" />

			</div>
			<!-- Custom template example -->
			<notifications group="custom-template" :max=1 :duration="50000000" :width="500" position="bottom center">

				<template slot="body" slot-scope="props">
					<v-card color="error" class="custom-card" rounded="0">
						<v-toolbar flat color="error" class="white--text">
							<v-toolbar-title>
								{{ props.item.title }}
							</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn icon class="white--text" @click="props.close">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-toolbar>

						<v-card-text class="white--text">
							{{ props.item.text }}
						</v-card-text>

					</v-card>
				</template>

			</notifications>

		</v-container>
	</div>
</template>

<script>
/* eslint-disable */
import { debounce } from 'lodash';
import loading from "@/mixins/LoadingMixin";
import PrimaryGeofence from "./RequestDeforestationGeofence.vue"
import * as moment from "moment"
import gql from 'graphql-tag'
import FarmService from "@/_services/farmService";
import GeoFenceView from "@/components/GeoFenceView.vue"
import SelectFarmTypeDialog from "./SelectFarmTypeDialog.vue"
import { farmRules } from "@/validations/FarmFormRules.js";
import FarmLocationNonRegistered from "../../views/my_farm/FarmLocationNonRegistered.vue"
import PromptDialog from "../common/PromptDialog.vue";

export default {
	name: 'Deforestation',
	components: {
		PrimaryGeofence,
		GeoFenceView,
		SelectFarmTypeDialog,
		PromptDialog,
		FarmLocationNonRegistered
	},
	async mounted() {
		document.title = "Deforestation";

		await this.getfarm()
	},
	async created() {
		// this.getFarmDetails()
	},
	computed: {
		dialogTitle() {
			if (this.selectedReport) {
				return `${this.selectedReport.locationName} - ${this.formatDate(this.selectedReport.createdAt)}`
			}
			return ''
		},
		deforestationImage() {
			if (this.selectedReport) {
				const satelliteImage = this.selectedReport.sateliteResponse && this.selectedReport.sateliteResponse.find(item => item.reportName === 'Deforestation')
				if (satelliteImage) {
					return satelliteImage.imagePath
				}
			}
			return ''
		},
		beforeImage() {
			if (this.selectedReport) {
				const satelliteImage = this.selectedReport.sateliteResponse && this.selectedReport.sateliteResponse.find(item => item.reportName === 'Image 2020')
				if (satelliteImage) {
					return satelliteImage.imagePath
				}
			}
			return ''
		}
	},
	data() {
		return {
			showPromptDialog: false,
			farmRules,
			selectedFarmRadio: null,
			tableKey: 0,
			selectedFarmStack: [],
			selectedFarm: {},
			farmListDialogModel: false,
			selectFarmDialog: false,
			registerFarmDialog: false,
			successDialog: false,
			showFarmLocation: false,
			farmNoRecordHeader: [
				this.$t('farm.farmOwner'),
				this.$t('farm.farmName'),
				this.$t('farm.farmType'),
				this.$t('farm.contractMating'),
				this.$t('farm.govtRegistry'),
				this.$t('farm.cooperativeID'),
			],
			farmAllSelectedHeaders: [
				this.$t('farm.farmName'),
				this.$t('farm.farmOwner'),
				this.$t('farm.farmType'),
				this.$t('farm.farmOwnershipType'),
				this.$t('farm.govtRegistry'),
				this.$t('farm.cooperativeID'),
				this.$t('farm.licenceNum'),
				// "Actions",
			],

			farmSelectedHeaders: [],
			farmTableHeaders: [],
			farmType: 'registered',
			farmHeaders: [

				{
					text: this.$t('Select'),
					value: "farmCheckBox",
					class: "black--text",
					sortable: false,
				},
				{
					text: this.$t('farm.farmName'),
					value: "farmName",
					class: "black--text",
					sortable: false,
				},
				{
					text: this.$t('farm.farmOwner'),
					value: "farmOwner",
					class: "black--text",
					sortable: false,
				},
				{
					text: this.$t('farm.farmOwnershipType'),
					value: "farmOwnershipType",
					class: "black--text",
					sortable: false,
				},
				{
					text: this.$t('farm.govtRegistry'),
					value: "govRegistrationNum",
					class: "black--text",
					sortable: false,
				},
				{
					text: this.$t('farm.cooperativeID'),
					value: "cooperativeId",
					class: "black--text",
					sortable: false,
				},
				{ text: this.$t('farm.licenceNum'), value: "licenceNum", class: "black--text", sortable: false, },
				// { text: "Actions", class: "black--text", sortable: false, },
				// {
				//   text: this.$t('farm.contractMating'),
				//   value: "contractMating",
				//   class: "black--text",
				//   sortable: false,
				// },
			],
			totalfarms: 1,
			farmTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
			selectedHeaders: [],
			oldSelected: [],
			tableHeaders: [
				{ text: this.$t('farm.farmName'), value: "farmName" },
				{ text: this.$t('farm.farmRegistrationID'), value: "farmRegistrationId" },
				{ text: this.$t('farm.farmerName'), value: "farmerName" },
				{ text: this.$t('farm.farmerRegistrationID'), value: "farmerRegistrationId" },
				{ text: this.$t('farm.farmLocation'), value: "locationName" },
				{ text: this.$t('farm.area'), value: "geofenceArea" },
				// { text: "Deforestation Area (HA)", value: "deforestationArea" },
				// { text: "Tree Gain Area (HA)", value: "treeGainArea" },
				// { text: "Current Forest Area (HA)", value: "forestArea2022" },
				{ text:this.$t('farm.dateOfRequest'), value: "createdAt" },
				{ text:this.$t('farm.status'), value: "status" },
				{ text:this.$t('deforestation.view'), value: "view" },
			],
			itemsPerPageOptions: [5, 10, 25, 50],
			farmItemsPerPageOptions: [5, 10, 25, 50],
			tabletSelectHeaders: [],
			todayOrderby: 'reportType',
			todayOrderType: 'desc',
			loaded: false,
			geofenceNameValid: false,
			newGeofenceName: '',
			showGeofenceNameModal: false,
			newGeofence: false,
			orgFarm: '',
			showMap: false,
			searchPhase: '',
			totalPastures: 0,
			todaytotalPastures: 0,
			todaytotalPages: 0,
			pastureMgmtAll: { rows: [] },
			pastureMgmtAllToday: { rows: [] },
			allSelectedHeaders: [
				"Name",
				"Date of Interest",
				"Report Type",
				"Request Date",
				"Status",
				"View",
				"Download"
			],
			reportHeaders: [
				{ text: "Name", value: "locationName" },
				{ text: "Date of Interest", value: "dateOfInterest" },
				{ text: "Report Type", value: "reportType" },
				{ text: "Request Date", value: "createdAt" },
				//    { text:"Location Info" ,value:"locationInfo"},
				{ text: "Status", value: "status" },
				{ text: "View", value: "view" },
				{ text: "Download", value: "download" },
			],
			tableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
			todayTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
			errors: {
				locationInfo: "",
				geofenceNameError: ""

			},
			locationInfoRules: [
				(v) => !!v || "Location Info is Required"
			],
			geofenceNameRules: [
				(v) => !!v || "Geofence name is Required"
			],
			dateRules: [
				(v) => ((new Date(v).getDate()) <= (new Date().getDate())) || "Future date selected"
			],
			reportFormValid: true,
			locationInfoModel: null,
			coordinatesModel: null,
			dateModal: false,
			dateOfInterest: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			loading: true,
			user: {
				name: "",
				role: "",
				userName: "",
			},
			breadcrumbs: [
				{
					text: this.$t("dashboard"),
					disabled: false,
					to: "/",
				},
				{
					text: this.$t("deforestation.eudrForestAssessment"),
					disabled: true,
					to: "/deforestation",
				},
			],
			mainTab: null,
			existingLocationTabs: null,
			to: "",
			from: "",
			totalDeforestations: "",
			todayto: 0,
			todayfrom: 0,
			totalPages: "",
			transition: true,
			pageCount: 1,
			currentrows: 0,
			search: "",
			selected: [],
			items: [],
			geofence: null,
			geofences: [],
			totaldrugs: 1,
			selectedItem: false,
			tabletTableOptions: { itemsPerPage: 10, page: 1, sortBy: [] },
			headers: [
				{
					text: "Name",
					align: "start",
					sortable: false,
					class: "black--text",
					value: "name",
				},
				{
					text: "Date of Interest",
					value: "dateOfInterest",
					class: "black--text",
				},
				{
					text: "Report Type",
					value: "reportType",
					class: "black--text",
				},
				{
					text: "Request Date",
					value: "requestDate",
					class: "black--text",
				},
				{
					text: "Location Info",
					value: "locationInfo",
					class: "black--text",
				},
				{
					text: "Status",
					value: "status",
					class: "black--text",
					sortable: false,
				},
			],
			showRequestSatelliteReportDialog: false,
			existingLocationDialog: false,
			confirmationDialog: false,
			optionDialog: false,
			pdfDialogDialog: false,
			currentPdfLink: '',
			customizeMenu: '',
			itemsPerPageSlider: '',
			farmItemsPerPageSlider: 0,
			customizeMenuAll: '',
			deforestationReports: [],
			viewImagesDialog: false,
			selectedReport: {},
			farm: {
				farmNumber: "",
				id: null,
				farmName: "",
				registrationNo: "",
				lat: 0,
				log: 0,
				address: "",
				area: 0,
				areaUomId: null,
				parameter: 0,
				parameterUomId: 0,
				farmingGoals: [],
				farmOwnershipType: "",
				farmGeofence: [],
				farmType: null,
				productionSystem: null,
				farmOwner: null,
				country: "",
				state: "",
				city: "",
				govRegistrationNum: "",
				contractMating: "",
				cooperativeId: "",
				cooperativeName: "",
				licenceNum: "",
				licenceExpiryDate: '',
				regulatorName: "",
				houseNum: "",
				street: "",
				regulatorRepresentiveName: "",
				communityName: "",
				farmRegistartionId: '',
				farmerRegistrationId: ''
			},
			requestDeforestationDialog: false,
			radioGroup: 1,
			showGeofenceOnMap: false,
			currentGeofenceLatLng: [],
			currentGeofenceLat: 0,
			currentGeofenceLng: 0,
			comparisionDialog: false
		};
	},
	watch: {
		farmTableOptions: {
			handler() {

				this.getfarm();
			},
			deep: true,
		},
	},
	methods: {
		viewReport(item) {
			this.$router.push({
				name: 'DeforestationDetails',
				params: { id: item.id },
			})
		},
		farmChecked(currentFarm) {
			this.selectedFarmStack.push(currentFarm)
			if (this.selectedFarmStack.length > 1) {
				let farmObj = this.selectedFarmStack.shift()
				this.items.forEach(el => {
					if (el.id == farmObj.id) {
						el.farmCheckBox = false
					}
				})
			}
			this.tableKey++
		},
		resetSearchOnEmpty() {

			this.farmTableOptions.page = 1;
			this.getfarm();

		},
		openFarmList() {
			this.farmListDialogModel = true
		},
		resetDefaut() {
			this.farmTableHeaders = this.farmHeaders;
			this.farmSelectedHeaders = this.farmAllSelectedHeaders;
			this.menu = false;
		},
		resetTableStructure() {
			this.startLoading();
			this.farmTableHeaders = this.farmHeaders.filter((header) =>
				this.farmSelectedHeaders.includes(header.text)
			);
			this.farmTableOptions.itemsPerPage = this.farmItemsPerPageOptions[this.farmItemsPerPageSlider];

			this.menu = false;
			// this.getfarm();
			this.stopLoading();
		},
		farmLocationClosed(data) {
			console.log('sss', data);
			this.showFarmLocation = false;
			this.farm.lat = data.lat;
			this.farm.log = data.log;
			this.farm.areaUomId = data.areaUomId;
			this.farm.area = data.area;
			this.farm.radius = data.radius;
			this.farm.address = data.address;
			this.farm.country = data.addressData.country
			this.farm.city = data.addressData.locality
			this.farm.state = data.addressData.administrative_area_level_1
			this.farm.street = data.addressData.postal_code
		},
		closeWithoutChange() {
			this.showMap = false
			this.showFarmLocation = false
			// this.geofenceValidation = true
		},
		farmPageChange(t) {
			if (t) this.farmTableOptions.page = this.farmTableOptions.page + 1;
			else this.farmTableOptions.page = this.farmTableOptions.page - 1;

			this.getfarm();
		},
		async getfarm() {
			this.selectedFarmStack = []
			this.loading = true;

			this.$apollo.queries.allUserFarms.skip = false;
			await this.$apollo.queries.allUserFarms.refetch();

			try {

				``
				this.items = this.allFarms.rows;
				this.currentrows = this.allFarms.fetchedRows;
				this.totalfarms = this.allFarms.count;

				if (this.totalfarms < 1) {
					this.oldSelected = this.farmSelectedHeaders;
					this.farmSelectedHeaders = this.noRecordHeader;
				} else {
					if (this.oldSelected.length > 1)
						this.farmSelectedHeaders = this.oldSelected;
					else {
						this.farmSelectedHeaders = this.farmAllSelectedHeaders;
						this.oldSelected = [];
					}
				}
				this.resetTableStructure();


				this.pageCount = Math.ceil(
					this.totalfarms / this.farmTableOptions.itemsPerPage
				);
				this.farmTotalPages = Math.ceil(
					this.totalfarms / this.farmTableOptions.itemsPerPage
				);
				this.farmFrom =
					(this.farmTableOptions.page - 1) * this.farmTableOptions.itemsPerPage + 1;
				this.farmTo =
					this.farmTableOptions.page * this.farmTableOptions.itemsPerPage -
					(this.farmTableOptions.itemsPerPage - this.allFarms.fetchedRows);
				this.loading = false;


			} catch (error) {
				this.loading = false;
				this.stopLoading();
			}

		},
		searchFarms() {
			if (this.search == "") return;

			this.farmTableOptions.page = 1;
			this.getfarm();

		},
		showGeofenceTool() {
			this.showMap = true
		},
		async locationMapClosed(gdata) {
			this.startLoading()
			// console.table(gdata, gdata)
			const coordinates = gdata?.farmGeofence.map(item => ({
				latitude: item.lat.toString(),
				longitude: item.log.toString()
			}));
			const data = {
				locationName: gdata.address,
				country: gdata.country,
				state: gdata.state,
				farmId: Number(this.farm.id),
				// dateOfInterest: new Date().toISOString().slice(0, 10),
				locationInfo: {
					type: 'polygon',
					coordinates
				}
			}
			if (gdata.zoneId) {
				data.zoneId = gdata.zoneId
			}
			this.$apollo.mutate({
				// Query
				mutation: gql`mutation ($data: CreateDeforestationInput!) {
          			createDeforestation(
						createDeforestationInput: $data
					)
        		}`,
				// Parameters
				variables: {
					data,
				},
			}).then(async res => {
				if (res.data.createDeforestation) {
					this.$notify({
						title: `Success`,
						text: 'Report generated successfully.',
						type: "success",
					});
					this.refreshTable()
					this.showMap = false
					this.requestDeforestationDialog = false
					this.selectFarmDialog = false;
					this.refreshTable()
					this.stopLoading()
				}
			}).catch(async error => {
				this.$notify({
					title: `Report cannot be added.`,
					text: error.message.split(":")[1],
					// text: "The server couldn't process your request, please contact your admin for further details",
					type: "error",
					position: "center",
					duration: 1000000
				});
				this.stopLoading()
			})
		},
		async refreshTable() {
			await this.$apollo.queries.deforestations.refetch()
		},
		formatDate(date) {
			return moment(date).format("DD/MM/YYYY")
		},
		showImages(data) {
			this.selectedReport = data
			this.viewImagesDialog = true
		},
		async getFarmDetails(id) {
			try {
				this.startLoading()
				this.orgFarm = ''
				const res = await FarmService.getPrimaryFarm(id);
				this.orgFarm = res.data;
				this.geofences = res?.data?.GeoFences;
				await this.assignValues(this.orgFarm);
				this.stopLoading()
			} catch (error) {
				console.log(error)
				// this.$notify({
				// 	title: `Primary farm not found.`,
				// 	text: 'Please register farm first',
				// 	type: "error",
				// });
			}
		},
		async assignValues(farm) {
			this.farm.id = farm.id,
				this.farm.farmName = farm.farmName,
				this.farm.registrationNo = null,
				this.farm.lat = farm.lat,
				this.farm.log = farm.log,
				this.farm.address = farm.address,
				this.farm.area = farm.area,
				this.farm.areaUomId = farm.areaUomId,
				this.farm.parameter = farm.parameter,
				this.farm.parameterUomId = 0,
				this.farm.farmingGoals = [],
				this.farm.farmOwnershipType = farm.farmOwnershipType,
				this.farm.farmGeofence = [],
				this.farm.farmType = farm.farmType,
				this.farm.productionSystem = typeof JSON.parse(farm.productionSystem) === 'object' ? JSON.parse(farm.productionSystem) : [JSON.parse(farm.productionSystem)],
				this.farm.farmOwner = farm.farmOwner,
				this.farm.country = farm.country,
				this.farm.state = farm.state,
				this.farm.city = farm.city,
				this.farm.govRegistrationNum = farm.govRegistrationNum,
				this.farm.contractMating = farm.contractMating,
				this.farm.cooperativeId = farm.cooperativeId,
				this.farm.cooperativeName = farm.cooperativeName,
				this.farm.licenceNum = farm.licenceNum,
				this.farm.licenceExpiryDate = this.formatDate(farm.licenceExpiryDate),
				this.farm.regulatorName = farm.regulatorName,
				this.farm.houseNum = farm.houseNum,
				this.farm.street = farm.street,
				this.farm.regulatorRepresentiveName = farm.regulatorRepresentiveName
			this.farm.coordinates = farm.FarmCoordinates
			this.farm.communityName = farm.communityName
			this.farm.farmNumber = farm.farmNumber
			return Promise.resolve(true)
		},
		requestDeforestationReport() {
			if (this.radioGroup === 1) {
				const gdata = {
					farmGeofence: this.farm.coordinates,
					address: this.farm.address,
					country: this.farm.country,
					state: this.farm.state
				}
				this.requestDeforestationDialog = false
				this.locationMapClosed(gdata)
			} else {
				this.showGeofenceTool()
			}
		},
		async requestReportFromFarmSelection() {
			await this.assignValues(this.orgFarm)
			console.log('farm data', this.farm, this.geofences)
			if (this.farm) {
				const gdata = {
					farmGeofence: this.farm.coordinates,
					address: this.farm.address,
					country: this.farm.country,
					state: this.farm.state
				}
				if (this.geofence) {
					gdata.zoneId = parseInt(this.geofence.id)
					gdata.farmGeofence = this.geofence.geofenceCoordinates
					gdata.address = this.farm.address
					gdata.country = this.farm.country
					gdata.state = this.farm.state

				}
				this.farmListDialogModel = false
				this.requestDeforestationDialog = false
				this.locationMapClosed(gdata)
			} else {
				this.$notify({
					title: `No Geofence data found for this farm. Please select another farm or create geofence for it`,
					type: "success",

				});
			}

		},
		async requestNonRegisteredReport() {
			if (!this.$refs.registerForm.validate()) {
				return;
			}
			this.startLoading()
			// console.table(gdata, gdata)
			const coordinates = {
				latitude: this.farm.lat.toString(),
				longitude: this.farm.log.toString()
			}
			const data = {
				locationName: this.farm.address,
				country: this.farm.country,
				state: this.farm.state,
				farmRegistrationId: this.farm.farmRegistrationId,
				farmerRegistrationId: this.farm.farmerRegistrationId,
				farmName: this.farm.farmName,
				farmerName: this.farm.farmerName || this.farm.farmOwner || `${this.$store.getters.getUser.firstName} ${this.$store.getters.getUser.lastName}`,
				latitude: this.farm.lat,
				longitude: this.farm.log,
				radius: Number(this.farm.radius),
				geofenceArea: parseFloat(this.farm.area),
				// areaUomId: this.farm.areaUomId,
				reportType: 'NON_REGISTERED_FARM',
				locationInfo: {
					type: 'circle',
					coordinates
				}
			}
			this.$apollo.mutate({
				// Query
				mutation: gql`mutation ($data: CreateDeforestationInput!) {
          			createDeforestation(
						createDeforestationInput: $data
					)
        		}`,
				// Parameters
				variables: {
					data,
				},
			}).then(async res => {
				if (res.data.createDeforestation) {
					this.$notify({
						title: `Success`,
						text: 'Report generated successfully.',
						type: "success",
					});
					this.refreshTable()
					this.showMap = false
					this.registerFarmDialog = false
					this.selectFarmDialog = false;
					this.successDialog = true;
					this.stopLoading()
				}
			}).catch(async error => {
				console.log(error)
				this.$notify({
					title: `Report cannot be added.`,
					text: error.message.split(":")[1],
					// text: "The server couldn't process your request, please contact your admin for further details",
					type: "error",
					position: "center",
					duration: 1000000
				});
				this.stopLoading()
			})
		},
		geoFenceMapView(data) {
			this.selectedReport = data

			var codes = [];
			data.coordinates.map(function (elm) {
				codes.push({ lat: parseFloat(elm['latitude']), lng: parseFloat(elm['longitude']) });
			});

			this.currentGeofenceLatLng = codes;
			this.currentGeofenceLat = this.farm.lat
			this.currentGeofenceLng = this.farm.log
			this.showGeofenceOnMap = true;
		},
		geoFenceMapViewClosed() {
			this.showGeofenceOnMap = false;
		},
		compareImages(data) {
			this.selectedReport = data
			this.comparisionDialog = true
		},
		pageChange(t) {
			if (t) {
				this.tableOptions.page = this.tableOptions.page + 1
				return
			} else {
				this.tableOptions.page = this.tableOptions.page - 1
				return
			}
		},
	},
	mixins: [loading],
	apollo: {
		deforestations: {
			query() {
				return gql`query assessmentReports($page: Int!, $limit: Int!, $search: String!, $adminReportType: String!) {
					assessmentReports(getDeforestationInput:{search: $search, page: $page, limit: $limit, adminReportType: $adminReportType}) {
						rows {
							id
							status
							farmId
							userId
							farmName
							farmerName
							farmRegistrationId
      						farmerRegistrationId
							farm {
								userAssoc{
									firstName
									lastName
								}
							}
							userId
							locationName
							centerLatitude
							centerLongitude
							geofenceArea
							coordinates {
								latitude
								longitude
							}
							deforestationArea
							deforestationPercent      
							treeGainArea
							treeGainPercent
							forestArea2020
							forestArea2022
							forestArea2020Percent
							forestArea2022Percent
							isDeleted
							createdAt
							sateliteResponse {
								reportName
								satelliteSource
								imageName
								imagePath
								imgS3Key
								status
								createdAt
							}		
						}
						count
						totalCount
					}
				}`
			},
			variables() {
				return {
					page: this.tableOptions.page,
					limit: this.tableOptions.itemsPerPage,
					search: this.searchPhase,
					adminReportType: "eudr-assessment"
				}
			},
			update: data => data.assessmentReports,
			async result({ data }) {
				// this.startLoading()
				this.totalDeforestations = await data.assessmentReports.totalCount
				data.assessmentReports.rows.forEach(el => {
					el.geofenceArea = parseFloat(el.geofenceArea).toFixed(3)
					el.deforestationArea = parseFloat(el.deforestationArea).toFixed(3)
					el.treeGainArea = parseFloat(el.treeGainArea).toFixed(3)
					el.forestArea2022 = parseFloat(el.forestArea2022).toFixed(3)

				})
				this.totalPages = await Math.ceil(
					this.totalDeforestations / this.tableOptions.itemsPerPage
				)
				this.from = await (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1
				this.to =
					await this.tableOptions.page * this.tableOptions.itemsPerPage -
					(this.tableOptions.itemsPerPage - data.assessmentReports.count)
				// this.stopLoading()
				// setTimeout(() => {
				// 	this.stopLoading()
				// }, 500)
			},
			fetchPolicy: 'no-cache',
		},
		allUserFarms: {
			query: gql`
      query GetUserFarms($page: Int!, $limit: Int!, $searchPhrase: String!, $sortCol: String!, $sortOrder: String!) {
        allUserFarms(searchUserFarmInput: {
          page: $page,
          limit: $limit,
          searchPhrase: $searchPhrase,
          sortCol: $sortCol,
          sortOrder: $sortOrder,
        }) {
          count
          fetchedRows
          rows {
          id
          farmName
          registrationNo
          lat
          log
          address
          area
          areaUomId
          parameter
          parameterUomId
          farmOwnershipType
          farmType
          productionSystem
          farmOwner
          userId
          country
          state
          city
          govRegistrationNum
          contractMating
          cooperativeId
          cooperativeName
          licenceNum
          licenceExpiryDate
          regulatorName
          houseNum
          street
          regulatorRepresentiveName
          isDeleted
          farmingActivity
          farmNumber
          communityName
          FarmCoordinates {
            id
            lat
            log
          }
          GeoFences {
            id
            geofenceName
            geofenceArea
            geofenceAreaUOMId
            geofenceParameter
            geofenceCoordinates {
            id
            lat
            log
            }
          }
          farmTypeAssoc {
            id
            name
          }
          userAssoc {
            id
          }
          productionSystemAssoc {
            id
            name
          }
          createdAt
          }
        }
        }
      `,
			variables() {
				return {
					page: this.farmTableOptions.page,
					limit: this.farmTableOptions.itemsPerPage,
					searchPhrase: this.search,
					sortCol: "createdAt",
					sortOrder: "DESC"
				};
			},
			fetchPolicy: 'network-only',
			skip: () => true,
			result: function ({ data }) {
				if (data) {
					this.allFarms = data.allUserFarms
					this.items = data.allUserFarms.rows.map(el => {
						el.farmCheckBox = false
						return el
					})
					this.totalfarms = data.allUserFarms.count
					this.currentRows = data.allUserFarms.fetchedRows
				}
			},
			update: (data) => {
				return data.allUserFarms.rows;
			},
		},
	}
};
</script>

<style lang="scss" scoped>
.custom-template {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;

	text-align: left;
	font-size: 13px;
	margin: 5px;
	margin-bottom: 0;
	align-items: center;
	justify-content: center;

	&,
	&>div {
		box-sizing: border-box;
	}

	background: #ff6969;
	border: 2px solid #000000;


	.custom-template-icon {
		flex: 0 1 auto;
		color: #15C371;
		font-size: 32px;
		padding: 0 10px;
	}

	.custom-template-close {
		flex: 0 1 auto;
		margin-right: 5%;
		padding: 5px;
		font-size: 16px;
		background: #8d263c;
		cursor: pointer;
		border-radius: 100%;

		&:hover {
			opacity: 0.8;
		}
	}

	.tite {
		color: #117443;
		text-align: center;
		font-family: Poppins;
		font-size: 18px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
		letter-spacing: 0.18px;
	}

	.custom-template-content {
		padding: 10px;
		flex: 1 0 auto;

		.custom-template-title {
			letter-spacing: 1px;
			text-transform: uppercase;
			font-size: 10px;
			font-weight: 600;
		}
	}
}

.border {
	border: 2px solid;
	border-color: #dae1ec;
}

.v-tab {
	text-transform: none !important;
}

.input_pointer_cursor .v-input__control .v-input__slot {
	cursor: pointer !important;
}

.v-data-table-header th {
	white-space: nowrap;
}

.v-dialog--active {
	overflow: hidden !important;
}

.before-image,
.after-image {
	max-height: 60vh;
	padding: 40px 0;
}

.image-comparision-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.custom-animated-handle {
	transition: transform 0.2s;
	margin-left: -28px;
	opacity: 1 !important;
}

.slider-with-animated-handle:hover .custom-animated-handle {
	transform: scale(1.2);
	opacity: 1 !important;
}

.slider-with-animated-handle:focus .custom-animated-handle {
	transform: scale(1.2);
	opacity: 1 !important;
}

.slider-with-animated-handle:focus {
	--default-handle-opacity: 1 !important;
}


.slider-with-animated-handle {
	--default-handle-opacity: 1 !important;
	--divider-width: 4px;
	--divider-color: #5959FF;

}

.before-image-title {
	position: absolute;
	right: 50px;
	top: 100px;
	background-color: #E6F0E3;
	padding: 8px;
	border-radius: 8px;
	z-index: 1;
}

.after-image-title {
	position: absolute;
	left: 50px;
	top: 100px;
	background-color: #E6F0E3;
	padding: 8px;
	border-radius: 8px;
	z-index: 1;
}
</style>